<div class="modal-header border-0 p-0">
  <button type="button" class="btn white-font p-0 ml-auto mr-2" aria-label="Close" (click)="dialogRef.close()">
    <i class="fal fa-times"></i>
  </button>
</div>
<div class="navy-background justify-content-center mb-3 etreatment-form-container">
  <h6 class="modal-title white-font text-center">ASSIGN eTREATMENT FORM</h6>
</div>
<div class="flex-1 minh-0 px-2 pb-2">
  <div class="d-flex h-100">
    <div class="col-4">
      <kendo-grid
        [data]="treatmentForms"
        [sortable]="true"
        [selectable]="true"
        [style.height.%]="100"
        (selectionChange)="onSelectRow($event)"
      >
        <kendo-grid-column
          field="name"
          title="Name"
          [headerClass]="'teal-background white-font'"
          [class]="{ nameColumn: true }"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div class="d-flex">
              <span [ngClass]="{ 'k-disabled': alreadyAssigned(dataItem) }">{{ dataItem.name }}</span>
              <div *ngIf="dataItem.isSharedForm" class="ml-auto">
                <i class="far fa-cloud" title="Shared Form"></i>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column
          title="Add"
          min-width="55px"
          [width]="55"
          [headerClass]="'teal-background white-font'"
        >
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <div class="center">
              <span kendoTooltip title="{{ alreadyAssigned(dataItem) ? 'Form already assigned' : 'Assign Form' }}">
                <button
                  class="btn kendo-btn k-button"
                  (click)="assignTreatmentFormHandler(dataItem)"
                  [disabled]="alreadyAssigned(dataItem)"
                >
                  <i class="fal fa-plus-circle"></i>
                </button>
              </span>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
    <div class="col-8">
      <ng-scrollbar *ngIf="selectedForm" class="h-100">
        <div class="card card-outer">
          <div class="card-body">
            <div class="card bg-light">
              <app-form-viewer [form]="selectedForm" [editable]="false"></app-form-viewer>
            </div>
          </div>
        </div>
      </ng-scrollbar>
      <div *ngIf="!selectedForm" class="h-100 w-100 d-flex align-items-start justify-content-center px-0">
        <span class="m-auto font-weight-bold" style="font-size: 2em">Please select a form.</span>
      </div>
    </div>
  </div>
</div>
